export default "__VITE_ASSET__B$KI8tWl__"